import styled, { css } from 'styled-components'
import Button from 'design-system/button'
import { AI_TOOLBAR_ACTION_HEIGHT } from './aiEvaluationTokens'

const toolbarActionStyles = css`
  && {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: ${AI_TOOLBAR_ACTION_HEIGHT};
    min-height: ${AI_TOOLBAR_ACTION_HEIGHT};
    padding: 12px 16px;
    margin: 0;
    box-sizing: border-box;
    border-radius: 8px;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;

    svg {
      width: 16px !important;
      height: 16px !important;
    }
  }
`

export const MoveBlocksButton = styled(Button)`
  ${toolbarActionStyles}
`

export const CancelOrderButton = styled(Button)`
  ${toolbarActionStyles}

  && {
    margin-right: 8px;
  }
`

export const SaveOrderButton = styled(Button)`
  ${toolbarActionStyles}

  && {
    color: #36b37e;
    border: 2px solid #36b37e;
    background: #ffffff;

    svg {
      color: #36b37e !important;
    }

    &:hover:not(:disabled) {
      color: #36b37e;
      border-color: #36b37e;
      background: rgba(54, 179, 126, 0.08);
      opacity: 1;
    }

    &:focus {
      box-shadow: 0 0 0 2px rgba(54, 179, 126, 0.25);
    }
  }
`
